import { clsx } from 'clsx'

interface LoadingProps {
  fullScreen?: boolean
  text?: string
}

export default function Loading({ fullScreen = false, text }: LoadingProps) {
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center',
        fullScreen ? 'fixed inset-0 bg-white/80 z-modal' : 'py-16'
      )}
    >
      <div className="w-10 h-10 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin" />
      {text && <p className="mt-4 text-sm text-neutral-500">{text}</p>}
    </div>
  )
}
